import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { AllTrainingListService } from 'src/app/features/training/services/all-training-list.service';
import { TrainingDetailsService } from 'src/app/features/training/services/training-details.service';

@Component({
  templateUrl: './upload-proof.component.html',
  styles: [],
})
export class UploadProofComponent implements OnInit {
  loading = false;
  files = [];
  deletedFiles: any[] = [];
  attachedFiles: any[] = [];
  isSubmitted = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<UploadProofComponent>,
    private allTrainingListService: AllTrainingListService,
    private trainingDetailsService: TrainingDetailsService,
    private toastr: ToastrService
  ) {
  }

  ngOnInit(): void {
  }

  onSubmit() {
    this.isSubmitted = true;
    if (this.files.length) {
      this.loading = true;
      const model = {
        course_token: this.data.courseToken,
        payment_option: this.data.payment_option,
        attached_file: this.files,
        enrollment_token: null
      };
      if (this.data.TM_FM_Pay) { //when TM_FM_Pay fees for trainee front training detailes => tap "Payments"
        model.enrollment_token = this.data.enrollment_token
        this.allTrainingListService.TM_FM_Payment(model).subscribe(
          (res) => {
            this.toastr.success(res.message);
            this.dialogRef.close(true);
            this.trainingDetailsService.refreshTrainingDetails.next((new Date()).getTime())
            this.loading = false;
          },
          (err) => {
            // console.log(err);
            this.toastr.error(err.message);
            this.loading = false;
          }
        );
      } else { // when Trainee Pay For first Time
        this.allTrainingListService.traineePayment(model).subscribe(
          (res) => {
            this.toastr.success(res.message);
            this.dialogRef.close(true);
            this.trainingDetailsService.refreshTrainingDetails.next((new Date()).getTime())
            this.loading = false;
          },
          (err) => {
            // console.log(err);
            this.toastr.error(err.message);
            this.loading = false;
          }
        );
      }

    }
  }
}
